<div>
  <label class="input-label-item">
    @if (label) {
      <span>{{ label }}</span>
    }
    <select
      [ngClass]="variant === 'compact' ? 'select-compact' : 'select-base'"
      [formControl]="formControl"
      (change)="selectOption($event)"
    >
      @if (placeholder) {
        <option value="" disabled selected>
          {{ placeholder }}
        </option>
      }
      @for (option of options; track option.value) {
        <option [value]="option.value">
          {{ option.label }}
        </option>
      }
    </select>
  </label>
  @if (formControl.invalid && formControl.touched) {
    <div>
      @if (formControl.errors?.['required']) {
        <div class="input-error">Este campo es requerido</div>
      }
    </div>
  }
  @if (helpLabel) {
    <div class="input-help-label">{{ helpLabel }}</div>
  }
</div>
